import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomefirstScoresRoutingModule } from './homefirst-scores-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { PlayersCompletedComponent } from './players-completed/players-completed.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { HomefirstScoresComponent } from './homefirst-scores.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [PlayersCompletedComponent, HomefirstScoresComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    ReactiveFormsModule,
    HomefirstScoresRoutingModule,
  ],
})
export class HomefirstScoresModule {}
